export default "__VITE_ASSET__841b79a7__"